/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   useScrollXError.ts
 */

import { useEffect } from 'react'
import { logger } from '../../../logger'

export const useScrollXError = (watch?: unknown, additionalLogging?: string) => {
  useEffect(() => {
    if (window.document.documentElement.scrollWidth > document.documentElement.clientWidth) {
      logger.debug('Scroll X is occurring on this page. Please disable it.', {
        href: window.location.href,
        additional: additionalLogging,
      })
    }
  }, [watch])
}
